import "C:\\Users\\ZKLZ\\Desktop\\\u9879\u76EE\\\u6E1D\u9AD8\u6700\u65B0\u5F00\u53D1\u5730\u5740\\\u6E1D\u9AD8\u53C2\u5EFA\u65B9\u7CFB\u7EDF\u7BA1\u7406\u7AEF\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "C:\\Users\\ZKLZ\\Desktop\\\u9879\u76EE\\\u6E1D\u9AD8\u6700\u65B0\u5F00\u53D1\u5730\u5740\\\u6E1D\u9AD8\u53C2\u5EFA\u65B9\u7CFB\u7EDF\u7BA1\u7406\u7AEF\\node_modules\\core-js\\modules\\es6.promise.js";
import "C:\\Users\\ZKLZ\\Desktop\\\u9879\u76EE\\\u6E1D\u9AD8\u6700\u65B0\u5F00\u53D1\u5730\u5740\\\u6E1D\u9AD8\u53C2\u5EFA\u65B9\u7CFB\u7EDF\u7BA1\u7406\u7AEF\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "C:\\Users\\ZKLZ\\Desktop\\\u9879\u76EE\\\u6E1D\u9AD8\u6700\u65B0\u5F00\u53D1\u5730\u5740\\\u6E1D\u9AD8\u53C2\u5EFA\u65B9\u7CFB\u7EDF\u7BA1\u7406\u7AEF\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from 'vue';
import App from "./App.vue";
import router from "./router";
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from "./components/common/i18n";
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import "./assets/css/icon.css";
import "./components/common/directives";
import 'babel-polyfill';
import 'url-search-params-polyfill';
import eIconPicker from 'e-icon-picker';
import 'e-icon-picker/lib/symbol.js'; //基本彩色图标库
import 'e-icon-picker/lib/index.css'; // 基本样式，包含基本图标
import 'font-awesome/css/font-awesome.min.css'; //font-awesome 图标库
import 'element-ui/lib/theme-chalk/icon.css'; //element-ui 图标库

//全局删除增加图标
Vue.use(eIconPicker, {
  FontAwesome: true,
  ElementUI: true,
  eIcon: true,
  //自带的图标，来自阿里妈妈
  eIconSymbol: true,
  //是否开启彩色图标
  addIconList: [],
  removeIconList: [],
  zIndex: 3100 //选择器弹层的最低层,全局配置
});

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(ElementUI, {
  size: 'small'
});
var i18n = new VueI18n({
  locale: 'zh',
  messages: messages
});

//使用钩子函数对路由进行权限跳转
router.beforeEach(function (to, from, next) {
  document.title = "".concat(to.meta.title);
  // this.route.$forceUpdate();
  //     const role = localStorage.getItemroute.$forceUpdate();('ms_username');
  //     if (!role && to.path == '/index') {
  //         next('/index');
  //     } else if (to.meta.permission) {
  //         // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
  //         role === 'admin' ? next() : next('/403');
  //     } else {
  //         // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
  //         if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
  //             Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
  //                 confirmButtonText: '确定'
  //             });
  //         } else {
  next();
  //         }
  //     }
});

new Vue({
  router: router,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');